import type { IconSvgObject } from './types';

const FileScanIcon: IconSvgObject = [
  ["path", { d: "M8 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H13L20 9V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14H19C19.5523 14 20 14.4477 20 15V16M14 14H13C12.4477 14 12 14.4477 12 15V16M18 22H19C19.5523 22 20 21.5523 20 21V20M14 22H13C12.4477 22 12 21.5523 12 21V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileScanIcon;
